module.exports = __webpack_public_path__ + "media/components/src/assets/images/order-gift-packaging/sample-momotaro-img_a-f89b174ad034e077267312afdaf5c827.png";